import actionTypes from "./collection.type";

export function setDiscountCodeCollection(data) {
  return { type: actionTypes.SET_DISCOUNT_CODE_COLLECTION, payload: data };
}

export function clearDiscountCodeCollection() {
  return { type: actionTypes.CLEAR_DISCOUNT_CODE_COLLECTION };
}
